import { createKey } from './createKey';

const keyHandler = createKey('file');

export const FileServiceKeys = {
  key: keyHandler.key,
  search: keyHandler.createMethod(),
  getById: keyHandler.createMethod(),
};
